import loc from 'owa-localize';
import * as React from 'react';
import { MailIcons } from 'owa-mail-icons';
import { news } from 'owa-locstrings/lib/strings/news.locstring.json';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';

export default function NewsNodePlaceholder(): JSX.Element {
    return <TreeNode displayName={loc(news)} isRootNode={false} customIcon={MailIcons.News} />;
}
